<template>
  <div class="filters-buttons-container">
    <custom-button
      v-for="(filter, index) in filters"
      :key="'filter' + index"
      :label="filter.label"
      :icon="filter.icon"
      :icon-size="16"
      :icon-color="activeFilter === index ? '#ffffff' : filter.color"
      :height="'60px'"
      :width="'160px'"
      :label-color="activeFilter === index ? '#ffffff' : filter.color"
      :button-color="activeFilter === index ? filter.color : '#ffffff'"
      :button-styling="{
        'border-radius': '8px',
        'box-shadow': '0px 3.25px 3.25px 0px rgba(0, 0, 0, 0.25)',
        'border': '1px solid',
        'border-color': filter.color,
        'font-size': '15px',
        'line-height': '15px',
      }"
      @buttonClick="selectFilter(index)"
    />
  </div>
</template>

<script>
import CustomButton from '@/newComponents/_Atoms/CustomButton.vue';

export default {
  name: "FilterButtons",

  components: {
    CustomButton,
  },

  props: {
    filters: {
      type: Array,
      required: true,
    },

    activeFilter: {
      type: Number,
    },
  },

  methods: {
    selectFilter(index) {
      this.$emit('select-filter', index);
    },
  },

}
</script>

<style scoped>
.filters-buttons-container {
  display: flex;
  flex-direction: row;
  gap: 6px;
  margin-top: 12px;
}
</style>


// WEBPACK FOOTER //
// src/newComponents/_Molecules/FilterButtons.vue